module.exports = __webpack_public_path__ + "img/icon_square-x.2d9a05fd.svg";